import React, { ReactNode } from "react";
import "sass/components/ProductSection.scss";

type ProductSectionProps = {
  title: string;
  description?: string;
  icon?: string;
  children: ReactNode;
  refer: React.LegacyRef<HTMLDivElement> | undefined;
};

function ProductSection({
  title,
  description,
  icon,
  children,
  refer,
}: ProductSectionProps) {
  return (
    <div className="product-section-container" ref={refer}>
      <div className="product-section-title">
        {icon && <i className={`${icon} product-section-icon`} />}
        {title}
      </div>
      {description && (
        <div className="product-section-description">{description}</div>
      )}
      <div className="product-section-body">{children}</div>
    </div>
  );
}

ProductSection.defaultProps = {
  refer: undefined,
  description: undefined,
  icon: undefined,
};

export default ProductSection;
